import { useState } from "react";

import { InsuranceOwed } from "./InsuranceOwed";
import { PayoutBoard } from "./PayoutBoard";

/**
 * The Payouts screen: the crew payout board, and under it the insurance the
 * paid crews cost (ADR 0275).
 *
 * Both read the same work orders. Marking one paid or not paid on the board
 * changes a month's insurance, so every write on the board bumps the key the
 * insurance section loads by, and its figures follow.
 */
export function PayoutsScreen() {
  const [changes, setChanges] = useState(0);
  return (
    <>
      <PayoutBoard onChanged={() => setChanges((n) => n + 1)} />
      <InsuranceOwed reloadKey={changes} />
    </>
  );
}
